import Footer from '../Components/Footer';
import Forum from '../Components/ForumComp/Forum';
import Header from '../Components/Header';

function ForumPage() {

    return (
        <div>
            <Header/>
            <Forum/>
            <Footer/>
        </div>
    );
}

export default ForumPage;